import React, { useEffect, useState } from 'react';
import DatePicker from '../DatePicker/DatePicker';
import { FINANCIALS_DATE_PRESETS } from '../../utils/financialsDateRange';
import '../../styles/FormPage.css';
import './FinancialsDateRangeFilter.css';

function FinancialsDateRangeFilter({ fromDate, toDate, onRangeChange }) {
  const [draftFromDate, setDraftFromDate] = useState(fromDate);
  const [draftToDate, setDraftToDate] = useState(toDate);
  const [activePreset, setActivePreset] = useState('');

  useEffect(() => {
    setDraftFromDate(fromDate);
    setDraftToDate(toDate);
  }, [fromDate, toDate]);

  const handleDraftChange = (event) => {
    const { name, value } = event.target;
    setActivePreset('');
    if (name === 'fromDate') {
      setDraftFromDate(value);
      return;
    }
    setDraftToDate(value);
  };

  const applyDateFilter = () => {
    setActivePreset('');
    onRangeChange(draftFromDate, draftToDate);
  };

  const applyPreset = (preset) => {
    const range = preset.getRange();
    setActivePreset(preset.id);
    setDraftFromDate(range.fromDate);
    setDraftToDate(range.toDate);
    onRangeChange(range.fromDate, range.toDate);
  };

  return (
    <section className="financials-date-filter">
      <div className="financials-date-filter-row">
        <div className="financials-date-filter-field">
          <label htmlFor="fromDate">From date</label>
          <DatePicker
            id="fromDate"
            name="fromDate"
            value={draftFromDate}
            onChange={handleDraftChange}
          />
        </div>
        <div className="financials-date-filter-field">
          <label htmlFor="toDate">To date</label>
          <DatePicker
            id="toDate"
            name="toDate"
            value={draftToDate}
            onChange={handleDraftChange}
          />
        </div>
        <div className="financials-date-filter-actions">
          <button type="button" className="form-page-btn" onClick={applyDateFilter}>
            Apply dates
          </button>
        </div>
      </div>

      <div className="financials-date-preset-row">
        {FINANCIALS_DATE_PRESETS.map((preset) => (
          <button
            key={preset.id}
            type="button"
            className={`financials-date-preset-btn${activePreset === preset.id ? ' is-active' : ''}`}
            onClick={() => applyPreset(preset)}
          >
            {preset.label}
          </button>
        ))}
      </div>
    </section>
  );
}

export default FinancialsDateRangeFilter;
